<script>
	import { onMount } from 'svelte';
	import { fade } from 'svelte/transition';

	let canvas;
	let context;
	let time = 0;
	let rendered = false;

	let fillPixel = (size) => {
		const cols = canvas.offsetWidth / size;
		const rows = canvas.offsetHeight / size;

		for (let i = 0; i < cols; i++) {
			for (let ii = 0; ii < rows; ii++) {
				context.fillStyle = Math.random() > 0.5 ? '#000' : '#fff';
				context.fillRect(i * size, ii * size, size, size);
			}
		}

		rendered = true;
	};

	let fillNoise = () => {
		var imgd = context.createImageData(canvas.offsetWidth, canvas.offsetHeight);
		var pix = imgd.data;

		for (var i = 0, n = pix.length; i < n; i += 4) {
			//var c = 7 + Math.sin(i / 50000 + time / 7);
			pix[i] = pix[i + 1] = pix[i + 2] = Math.random() >= 0.5 ? 0 : 255;
			pix[i + 3] = 255; // 100% opaque
		}

		context.putImageData(imgd, 0, 0);
		time = (time + 1) % canvas.height;
		rendered = true;
	};

	onMount(() => {
		context = canvas.getContext('2d');
		fillPixel(2);
	});
</script>

<div in:fade class="container">
	<div>
		<div class="hole">
			{#if rendered}
				<svg width="100%" height="100%" viewBox="0 0 100 100">
					<mask id="mask">
						<circle cx="50" cy="50" r="50" fill="#FFFFFF" />
					</mask>
					<filter id="blur">
						<feGaussianBlur in="SourceGraphic" stdDeviation="2" />
					</filter>
					<g mask="url(#mask)" filter="url(#blur)">
						{#each [0, 1, 2, 3, 4, 5, 6, 7, 8, 9] as r}
							<rect width="10" height="10" x={r * 10} fill={r % 2 === 0 ? '#fff' : '#000'} />
							<rect width="10" height="10" x={r * 10} y="10" fill={r % 2 === 0 ? '#000' : '#fff'} />
							<rect width="10" height="10" x={r * 10} y="20" fill={r % 2 === 0 ? '#fff' : '#000'} />
							<rect width="10" height="10" x={r * 10} y="30" fill={r % 2 === 0 ? '#000' : '#fff'} />
							<rect width="10" height="10" x={r * 10} y="40" fill={r % 2 === 0 ? '#fff' : '#000'} />
							<rect width="10" height="10" x={r * 10} y="50" fill={r % 2 === 0 ? '#000' : '#fff'} />
							<rect width="10" height="10" x={r * 10} y="60" fill={r % 2 === 0 ? '#fff' : '#000'} />
							<rect width="10" height="10" x={r * 10} y="70" fill={r % 2 === 0 ? '#000' : '#fff'} />
							<rect width="10" height="10" x={r * 10} y="80" fill={r % 2 === 0 ? '#fff' : '#000'} />
							<rect width="10" height="10" x={r * 10} y="90" fill={r % 2 === 0 ? '#000' : '#fff'} />
						{/each}
					</g>
				</svg>
			{/if}
		</div>
	</div>
	<canvas class="absolute w-full h-full inset-0 " bind:this={canvas} />
</div>

<style>
.container {
  position: absolute;
  background-color: red;
  width:100vw;
  height: 100vh;
}
.container:first-child {
  width:100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.hole {
  position: relative;
  width: 80vw;
  max-width:400px;
  height: 80vw;
  z-index: 2;
}
canvas {
  position:absolute;
  width: 100%;
  height:100%;
}
</style>
